const config = {
  API_BASE_URL: "https://dev.hrms.zaraaq.com",
  LEAVES_LIST_ENDPOINT: "/bv1/api/v1/leaves/list",
  LEAVE_STATUS_ENDPOINT: "/bv1/api/v1/leaves/${id}/status",
  SIGNUP_ENDPOINT: "/bv1/api/v1/auth/signup",
  SIGNIN_ENDPOINT: "/bv1/api/v1/auth/login",
  ORG_SIGNUP_ENDPOINT: "/bv1/api/v1/auth/signup",
  COUNTRY_ENDPOINT: "/bv1/api/v1/location/countries",
  STATE_ENDPOINT: "/bv1/api/v1/location/states",
  DISTRICT_ENDPOINT: "/bv1/api/v1/location/districts",
  BANKNAME_ENDPOINT: "/bv1/api/v1/geo/bankName",
  DASHBOARD_ENDPOINT: "/bv1/api/v1/dashboard",
  CLIENT_LIST_ENDPOINT: "/bv1/api/v1/client/",
  CLIENT_ENDPOINT: "/bv1/api/v1/client",
  ADD_CLIENT_CONFIG_ENDPOINT: "/bv1/api/v1/client-configs",
  VIEW_CLIENT_CONFIG_ENDPOINT: "/bv1/api/v1/client-configs/",
  GET_VIEW_EMPLOYEES_ENDPOINT: "/bv1/api/v1/employees/list",
  ADD_EMPLOYEE_ENDPOINT: "/bv1/api/v1/employees",
  UPDATE_EMPLOYEE_ENDPOINT: "/bv1/api/v1/employees/",
  DELETE_EMPLOYEE_ENDPOINT: "/bv1/api/v1/employees/",
  ADD_RECRUITMENT_ENDPOINT: "/bv1/api/v1/recruitments",
  RECRUITMENT_LIST_ENDPOINT: "/bv1/api/v1/recruitments",
  ADD_CANDIDATES_ENDPOINT: "/bv1/api/v1/candidates",
  CANDIDATES_LIST_ENDPOINT: "/bv1/api/v1/candidates",
  ATTENDANCE_CONFIG_ENDPOINT: "/bv1/api/v1/attendance-config/add",
  ATTENDANCE_CONFIG_LIST_ENDPOINT: "/bv1/api/v1/attendance-config/list",
  SUBVENDOR_LIST_ENDPOINT: "/bv1/api/v1/subvendors/list",
  SUBVENDOR_DETAIL_ENDPOINT: "/bv1/api/v1/subvendors/",
  ADD_SUBVENDOR_ENDPOINT: "/bv1/api/v1/subvendors",
  PAYROLL_LIST_ENDPOINT: "/bv1/api/v1/payroll/list",
  ATTENDANCE_PAYSLIP_LIST_ENDPOINT: "/bv1/api/v1/attendance/payslip-list",
  ATTENDANCE_UPLOAD_ENDPOINT: "/bv1/api/v1/attendance/upload",
  DASHBOARD_ENDPOINTATTENDANCE_PAYSLIP_LIST_ENDPOINT:"/bv1/api/v1/attendance/payslip-list",
  CLIENT_INVOICE_LIST_ENDPOINT:"/bv1/api/v1/client-invoice/list",
  ONBOARDING_LIST_ENDPOINT: "/bv1/api/v1/onboarding/filter",
  ONBOARDING_VIEW_LIST_ENDPOINT: "/bv1/api/v1/onboarding",
  GET_EMPLOYEE_DETAIL_ENDPOINT: "/bv1/api/v1/employees/",
  EMPLOYEE_CONFIG_ENDPOINT: "/bv1/api/v1/employee-configs",
  ATTENDANCE_CONFIG_SHEET_ENDPOINT: "/bv1/api/v1/attendance-sheet",
  ATTENDANCE_CONFIG_SHIFT_ENDPOINT: "/bv1/api/v1/attendance-config",
  ATTENDENCE_PAYSLIP_GENERATE_ENDPOINT: "/bv1/api/v1/payroll/payslip-generate",
  SUBVENDOR_INVOICE_LIST_ENDPOINT: "/bv1/api/v1/sub-vendor-invoice/list",
  ATTENDENCE_LIST_ENDPOINT: "/bv1/api/v1/attendance/report",
  ATTENDANCE_PAYSLIP_LIST_ENDPOINT: "/bv1/api/v1/attendance/payslip-list",
  UPDATE_RECUIRMTENT_STATUS_ENDPOINT: "/bv1/api/v1/recruitments",
  UPDATE_RECRUITMENT_STATUS_ENDPOINT: "/bv1/api/v1/candidates/status-update",
  UPDATE_CANDIDATE_TO_ONBOARDING_ENDPOINT: "/bv1/api/v1/onboarding",
  UPDATE_EMPLOYEE_STATUS_ENDPOINT: "/bv1/api/v1/employees/update-status",
  SALARY_CONFIG_ENDPOINT: "/bv1/api/v1/salary-config/add",
  SALARY_CONFIG_LIST_ENDPOINT: "/bv1/api/v1/salary-config/list",
  SALARY_CONFIG_DELETE_ENDPOINT: "/bv1/api/v1/salary-config/delete",
  WORK_SITE_ENDPOINT: "/bv1/api/v1/client/work-sites",
  SALARY_CONFIG_VIEW_ENDPOINT: "/bv1/api/v1/salary-config/view",
  CLIENT_INVOICE_GENERATE_ENDPOINT: "/bv1/api/v1/client-invoice/generate",
  SUBVENDOR_INVOICE_GENERATE_ENDPOINT: "/bv1/api/v1/sub-vendor-invoice/generate",
  JOB_ROLE_ENDPOINT: "/bv1/api/v1/client-configs/job-role",
  CLIENT_INVOICE_DETAIL_ENDPOINT: "/bv1/api/v1/client-invoice/details",
  EMPLOYEE_PAYROLL_ENDPOINT: "/bv1/api/v1/payroll/employee-payroll",
  SUBVENDOR_INVOICE_DETAIL_ENDPOINT: "/bv1/api/v1/sub-vendor-invoice/details",
  ATTENDANCE_DETAIL_ENDPOINT: "/bv1/api/v1/attendance/employee-view",
  CLIENT_INVOICE_DELETE_ENDPOINT: "/bv1/api/v1/client-invoice/delete",
  ATTENDANCE_SUMMARY_ENDPOINT: "/bv1/api/v1/attendance/attendance-summary",
  GENERATE_PRESIGNED_URL_ENDPOINT: "/bv1/api/v1/img/generate-presigned-url",
  VIEW_PRESIGNED_URL_ENDPOINT: "/bv1/api/v1/img/view-presigned-url",
  PROFILE_ENDPOINT: "/bv1/api/v1/auth/profile",
  DELETE_FILE_ENDPOINT: "/bv1/api/v1/img/delete-file",
  UPDATE_USER_IMAGE_ENDPOINT: "/bv1/api/v1/user/update-image",
  FORGOT_PASSWORD_ENDPOINT: "/bv1/api/v1/auth/forgot-password",
  RESET_PASSWORD_ENDPOINT: "/bv1/api/v1/auth/reset-password",
  OTP_SEND_ENDPOINT: "/bv1/api/v1/otp/send",
  SALARY_CONFIG_EDIT_ENDPOINT: "/bv1/api/v1/salary-config/edit",
  OTP_VERIFY_ENDPOINT: "/bv1/api/v1/otp/verify",
  CHANGE_PASSWORD_ENDPOINT: "/bv1/api/v1/users/change-password",
  PAYROLL_DASHBOARD_ENDPOINT: "/bv1/api/v1/payroll/dashboard",
  PAYROLL_DASHBOARD_VIEW_ENDPOINT: "/bv1/api/v1/payroll/dashboard/view",
  ESI_PF_REPORT_ENDPOINT: "/bv1/api/v1/payroll/dashboard/esi-pf-report",
  BULK_EMPLOYEE_UPLOAD_ENDPOINT: "/bv1/api/v1/employees/bulk/update",
  BULK_EMPLOYEE_TEMPLATE_ENDPOINT: "/bv1/api/v1/employees/template",
};


// const config = {
//   API_BASE_URL: "http://localhost:8081",
//   CLIENT_INVOICE_LIST_ENDPOINT: "/api/v1/client-invoice/list",
//   LEAVES_LIST_ENDPOINT: "/api/v1/leaves/list",
//   LEAVE_STATUS_ENDPOINT: "/api/v1/leaves/${id}/status",
//   SIGNIN_ENDPOINT: "/api/v1/auth/login",
//   ORG_SIGNUP_ENDPOINT: "/api/v1/auth/signup",
//   COUNTRY_ENDPOINT: "/api/v1/location/countries",
//   STATE_ENDPOINT: "/api/v1/location/states",
//   DISTRICT_ENDPOINT: "/api/v1/location/districts",
//   BANKNAME_ENDPOINT: "/api/v1/geo/bankName",
//   DASHBOARD_ENDPOINT: "/api/v1/dashboard",
//   CLIENT_LIST_ENDPOINT: "/api/v1/client/",
//   CLIENT_ENDPOINT: "/api/v1/client",
//   ADD_CLIENT_CONFIG_ENDPOINT: "/api/v1/client-configs",
//   VIEW_CLIENT_CONFIG_ENDPOINT: "/api/v1/client-configs/",
//   GET_VIEW_EMPLOYEES_ENDPOINT: "/api/v1/employees/list",
//   GET_EMPLOYEE_DETAIL_ENDPOINT: "/api/v1/employees/",
//   ADD_EMPLOYEE_ENDPOINT: "/api/v1/employees",
//   UPDATE_EMPLOYEE_ENDPOINT: "/api/v1/employees/",
//   UPDATE_EMPLOYEE_STATUS_ENDPOINT: "/api/v1/employees/update-status",
//   DELETE_EMPLOYEE_ENDPOINT: "/api/v1/employees/",
//   ADD_RECRUITMENT_ENDPOINT: "/api/v1/recruitments",
//   RECRUITMENT_LIST_ENDPOINT: "/api/v1/recruitments",
//   ADD_CANDIDATES_ENDPOINT: "/api/v1/candidates",
//   CANDIDATES_LIST_ENDPOINT: "/api/v1/candidates",
//   ATTENDANCE_CONFIG_ENDPOINT: "/api/v1/attendance-config/add",
//   ATTENDANCE_CONFIG_LIST_ENDPOINT: "/api/v1/attendance-config/list",
//   SUBVENDOR_LIST_ENDPOINT: "/api/v1/subvendors/list",
//   SUBVENDOR_DETAIL_ENDPOINT: "/api/v1/subvendors/",
//   ADD_SUBVENDOR_ENDPOINT: "/api/v1/subvendors",
//   PAYROLL_LIST_ENDPOINT: "/api/v1/payroll/list",
//   ATTENDANCE_UPLOAD_ENDPOINT: "/api/v1/attendance/upload",
//   ATTENDANCE_PAYSLIP_LIST_ENDPOINT: "/api/v1/attendance/payslip-list",
//   ONBOARDING_LIST_ENDPOINT: "/api/v1/onboarding/filter",
//   ONBOARDING_VIEW_LIST_ENDPOINT: "/api/v1/onboarding",
//   DASHBOARD_ENDPOINTATTENDANCE_PAYSLIP_LIST_ENDPOINT: "/api/v1/attendance/payslip-list",
//   EMPLOYEE_CONFIG_ENDPOINT: "/api/v1/employee-configs",
//   ATTENDANCE_CONFIG_SHEET_ENDPOINT: "/api/v1/attendance-sheet",
//   ATTENDANCE_CONFIG_SHIFT_ENDPOINT: "/api/v1/attendance-config",
//   ATTENDENCE_PAYSLIP_GENERATE_ENDPOINT: "/api/v1/payroll/payslip-generate",
//   SUBVENDOR_INVOICE_LIST_ENDPOINT: "/api/v1/sub-vendor-invoice/list",
//   ATTENDENCE_LIST_ENDPOINT: "/api/v1/attendance/report",
//   UPDATE_RECUIRMTENT_STATUS_ENDPOINT: "/api/v1/recruitments",
//   UPDATE_RECRUITMENT_STATUS_ENDPOINT: "/api/v1/recruitments/status",
//   UPDATE_RECRUITMENT_STATUS_ENDPOINT: "/api/v1/candidates/status-update",
//   UPDATE_CANDIDATE_TO_ONBOARDING_ENDPOINT: "/api/v1/onboarding",
//   SALARY_CONFIG_ENDPOINT: "/api/v1/salary-config/add",
//   SALARY_CONFIG_VIEW_ENDPOINT: "/api/v1/salary-config/view",
//   SALARY_CONFIG_LIST_ENDPOINT: "/api/v1/salary-config/list",
//   WORK_SITE_ENDPOINT: "/api/v1/client/work-sites",
//   CLIENT_INVOICE_GENERATE_ENDPOINT: "/api/v1/client-invoice/generate",
//   SUBVENDOR_INVOICE_GENERATE_ENDPOINT: "/api/v1/sub-vendor-invoice/generate",
//   JOB_ROLE_ENDPOINT: "/api/v1/client-configs/job-role",
//   CLIENT_INVOICE_DETAIL_ENDPOINT: "/api/v1/client-invoice/details",
//   EMPLOYEE_PAYROLL_ENDPOINT: "/api/v1/payroll/employee-payroll",
//   SUBVENDOR_INVOICE_DETAIL_ENDPOINT: "/api/v1/sub-vendor-invoice/details",
//   SALARY_CONFIG_EDIT_ENDPOINT: "/api/v1/salary-config/edit",
//   SALARY_CONFIG_DELETE_ENDPOINT: "/api/v1/salary-config/delete",
//   ATTENDANCE_DETAIL_ENDPOINT: "/api/v1/attendance/employee-view",
//   CLIENT_INVOICE_DELETE_ENDPOINT: "/api/v1/client-invoice/delete",
//   ATTENDANCE_SUMMARY_ENDPOINT: "/api/v1/attendance/attendance-summary",
//   GENERATE_PRESIGNED_URL_ENDPOINT: "/api/v1/img/generate-presigned-url",
//   VIEW_PRESIGNED_URL_ENDPOINT: "/api/v1/img/view-presigned-url",
//   PROFILE_ENDPOINT: "/api/v1/auth/profile",
//   DELETE_FILE_ENDPOINT: "/api/v1/img/delete-file",
//   UPDATE_USER_IMAGE_ENDPOINT: "/api/v1/user/update-image",
//   FORGOT_PASSWORD_ENDPOINT: "/api/v1/auth/forgot-password",
//   RESET_PASSWORD_ENDPOINT: "/api/v1/auth/reset-password",
//   OTP_SEND_ENDPOINT: "/api/v1/otp/send",
//   OTP_VERIFY_ENDPOINT: "/api/v1/otp/verify",
//   CHANGE_PASSWORD_ENDPOINT: "/api/v1/users/change-password",
//   PAYROLL_DASHBOARD_ENDPOINT: "/api/v1/payroll/dashboard",
//   PAYROLL_DASHBOARD_VIEW_ENDPOINT: "/api/v1/payroll/dashboard/view",
//   ESI_PF_REPORT_ENDPOINT: "/api/v1/payroll/dashboard/esi-pf-report",
//   BULK_EMPLOYEE_UPLOAD_ENDPOINT: "/api/v1/employees/bulk/update",
//   BULK_EMPLOYEE_TEMPLATE_ENDPOINT: "/api/v1/employees/template",
// };

export default config;
